// extracted by mini-css-extract-plugin
module.exports = {"title":"search-header_title__2M61A","inner":"search-header_inner__Jawgw"};